import { PerfilEnum } from '../enum/perfil';


export class Usuario {

  constructor(public username?: string,
    public email?: string,
    public nome?: string,
    public password?: string,
    public passwordConfirm?: string,
    public perfil?: PerfilEnum,
    public tokenAcess?: string,
    public tokenRefresh?: string,
    public pessoaJuridica?: boolean,
    public sugereAlterarSenha?: boolean,
    public docuwareAuthToken?: string) { }

  public static converterPerfil(strPerfil: string): PerfilEnum {
    let perfil: PerfilEnum;
    switch (strPerfil) {
      case 'ADMIN':
        perfil = PerfilEnum.ADMIN;
        break;
      case 'PRESTADOR':
        perfil = PerfilEnum.PRESTADOR;
        break;
      case 'MARKETING':
        perfil = PerfilEnum.MARKETING;
        break;
    }

    return perfil;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/base/vo/usuario.ts